exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-main[data-v-346f5914] {\n  min-height: 100vh;\n  background-color: #d02118;\n  overflow: hidden;\n}\n.module-main .banner[data-v-346f5914] {\n  position: relative;\n}\n.module-main .banner img[data-v-346f5914] {\n  width: 100%;\n}\n.module-main .banner .rule[data-v-346f5914] {\n  position: absolute;\n  right: -10px;\n  top: 8vw;\n  padding: 7px 15px;\n  background-color: #ffcb4c;\n  border-bottom: 3.5px solid #ff986f;\n  color: #964238;\n  font-size: 14px;\n  border-radius: 5px;\n}\n", ""]);

// exports
